import React from "react";

export const Chip = ({ active, children, onClick, testId }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={testId}
    className={`px-4 py-2.5 rounded-full text-sm font-semibold border transition-transform duration-200 hover:-translate-y-0.5 ${
      active
        ? "bg-[#052F24] text-[#DFFF00] border-[#052F24]"
        : "bg-transparent text-[#052F24] border-[#052F24]/20 hover:border-[#052F24]/50"
    }`}
  >
    {children}
  </button>
);
